export default __webpack_public_path__ + "static/3-1d5b94766c200f3d1e8193d160681d83.png";